<template>
  <v-layout>
    <v-flex xs12>
      <business-trip-imposition-form
        v-model="item" deletable
        @close="close" @save="save" @input="change" @delete="_delete" v-if="loaded"/>
      <Confirmation :title="confirmation.title"
                    :message="confirmation.message"
                    :buttons="confirmation.buttons"
                    ref="confirmation"
      />
    </v-flex>
  </v-layout>
</template>

<script>
import BusinessTripImpositionForm from './BusinessTripImpositionForm'
import Confirmation from '@/components/dialogs/Confirmation'

export default {
  name: 'business-trip-imposition-detail',
  components: {
    BusinessTripImpositionForm,
    Confirmation
  },
  data () {
    return {
      item: {organization: {}},
      confirmation: {},
      modified: false,
      loaded: false
    }
  },
  methods: {
    close () {
      const self = this
      if (this.modified) {
        self.confirmation = Object.assign({},
          { title: 'Business Trip Imposition changed. Data will not saved.',
            message: 'Are you sure?',
            buttons: [
              {label: 'Yes', handler: () => self.$router.push({name: 'business-trip-imposition'}), color: 'info'},
              {label: 'No', handler: () => { self.$refs.confirmation.close() }, color: 'warning'}
            ]})
        self.$refs.confirmation.show()
      } else {
        this.$router.push({name: 'business-trip-imposition'})
      }
    },
    save () {
      const self = this
      self.$store.dispatch('BusinessTripImposition/update', {item: self.item, vueinstance: self})
        .then(res => {
          self.item = res
          self.modified = false
          self.close()
          self.$success('Data saved')
        })
        .catch(err => self.$error(err))
    },
    change () {
      this.modified = true
    },
    _delete () {
      const self = this
      self.confirmation = Object.assign({},
        { title: 'Delete Business Trip Imposition ' + self.item.impositionName,
          message: 'Are you sure?',
          buttons: [
            { label: 'Yes',
              handler: () => {
                self.$store.dispatch('BusinessTripImposition/delete', {item: self.item, vueinstance: self})
                  .then(res => {
                    self.modified = false
                    self.$warning('Business Trip Imposition ' + res.impositionName + ' deleted')
                    self.$refs.confirmation.close()
                    self.close()
                  })
                  .catch(err => {
                    self.$error(err)
                    self.$refs.confirmation.close()
                  })
              },
              color: 'info'},
            {label: 'No', handler: () => { self.$refs.confirmation.close() }, color: 'warning'}
          ]})
      self.$refs.confirmation.show()
    },
    loadData () {
      const self = this
      self.$store.dispatch('BusinessTripImposition/get', {id: self.$route.params.id, vueinstance: self})
        .then(res => {
          self.item = res
          self.loaded = true
        })
        .catch(err => { self.$error(err) })
    }
  },
  mounted () {
    this.loadData()
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/master/BusinessTripImpositionDetail.vue